import BaseReducer from "../../utilities/BaseReducer";
import LocationAction from "./LocationAction";

// LocationReduser
export default class LocationReduser extends BaseReducer {
  initialState = {
    influencer_location: [],
  };
  [LocationAction.REQUEST_LOCATION_FINISHED](state, action) {
    return {
      ...state,
      influencer_location: action.payload,
    };
  }
}
